import type { ReactChildren } from '@fluentui/react-northstar';
import React, { useEffect } from 'react';
import { useElementalPage } from '../../context/ElementalPageContext';
import { Dialog, pxToRem, useStyles } from '@archipro-design/aria';
import { CloseIcon } from '@fluentui/react-icons-northstar';
import { useSearchParams } from '@remix-run/react';
import * as S from './ModalWrapper.style';
import { useAppData } from '@modules/root';

interface EcommerceModalWrapperProps {
    children: ReactChildren;
}

export const ModalWrapper = ({ children }: EcommerceModalWrapperProps) => {
    const { dispatch, state } = useElementalPage();
    const { css } = useStyles();

    const { user } = useAppData();

    useEffect(() => {
        let receivedURL = '',
            hubspotFieldInfo = '';
        if (user?.__typename === 'Me') {
            receivedURL = user.EcommerceBookingURL;
            hubspotFieldInfo = `&firstname=${user.FirstName}&lastname=${
                user.LastName
            }&email=${user.Email}&phone=${user.Phone}&company=${
                user.Professionals.length === 1
                    ? user.Professionals[0]?.Title ?? ''
                    : ''
            }`;
        }

        if (user?.__typename === 'Guest') {
            receivedURL = user.EcommerceBookingURL;
        }

        if (receivedURL) {
            receivedURL = receivedURL.concat(
                receivedURL.includes('?') ? '&' : '?',
                'embed=true',
                hubspotFieldInfo
            );
            dispatch({ type: 'setURL', value: receivedURL });
        }
    }, [dispatch, user]);

    const [searchParams, setSearchParams] = useSearchParams();

    useEffect(() => {
        const modalParam = searchParams.has('openModal');

        if (!state.meetingBooked && modalParam) {
            searchParams.delete('openModal');
            setSearchParams(searchParams);
            dispatch({ type: 'toggleModal', value: true });
        }

        const messageHook = (event: MessageEvent) => {
            if (event.isTrusted && event.data === 'scheduleDone') {
                dispatch({ type: 'toggleModal', value: true });
            }

            if (
                event.isTrusted &&
                Boolean(event.data['meetingBookSucceeded'])
            ) {
                dispatch({
                    type: 'toggleModal',
                    value: !event.data['meetingBookSucceeded'],
                });
                dispatch({
                    type: 'setMeetingBooked',
                });
            }
        };

        window.addEventListener('message', messageHook);
        return () => {
            window.removeEventListener('message', messageHook);
        };
    }, [dispatch, searchParams, setSearchParams, state.meetingBooked]);

    return (
        <div>
            <Dialog
                open={state.modalOpen}
                onOpen={() => {
                    dispatch({ type: 'toggleModal' });
                }}
                onConfirm={() => {
                    dispatch({ type: 'toggleModal' });
                }}
                onCancel={() => {
                    dispatch({ type: 'toggleModal' });
                }}
                header="Schedule a demo"
                headerAction={{
                    icon: (
                        <CloseIcon
                            className={css({
                                width: `${pxToRem(24)} !important`,
                                height: `${pxToRem(24)} !important`,
                            })}
                        />
                    ),
                    title: 'Close',
                    onClick: () => {
                        dispatch({ type: 'toggleModal' });
                    },
                    style: {
                        margin: pxToRem(24),
                        outline: 'none',
                    },
                }}
                content={{
                    content: (
                        <iframe
                            title="shedule a demo"
                            src={state.demoURL}
                            width="100%"
                            height="100%"
                            frameBorder="0"
                        ></iframe>
                    ),
                    style: {
                        height: '100%',
                        overflow: 'hidden',
                    },
                }}
                className={css(S.DialogStyles)}
                style={{ overflow: 'hidden' }}
                footer={{
                    style: { padding: '0' },
                }}
            />
            {children}
        </div>
    );
};
